const companions = document.querySelector('.companions__wrapper');
if (typeof(companions) != 'undefined' && companions != null) {
    for (let i = companions.children.length; i >= 0; i--) {
        companions.appendChild(companions.children[Math.random() * i | 0]);
    }
}
